import { selector } from 'recoil';

export default function reducerSelector({ selectorKey, selectorAtom, reducer }) {
  return selector({
    key: selectorKey,
    get: ({ get }) => get(selectorAtom),
    set: ({ set }, action) => {
      set(selectorAtom, (previousValue) => reducer(previousValue, action));
    },
  });
}
